import { all } from 'redux-saga/effects';

import { createMessage } from './createMessage';
import messagesVisibility from './messagesVisibility';

export default function* () {
    yield all([messagesVisibility(), createMessage()]);
}
